/**
 * @returns {{name: string|null, id: string}|null}
 */
export const getCurrentVariation = () => {
  try {
    if (!window.optimizely || !window.optimizely.get) {
      return null;
    }

    const state = window.optimizely.get('state');

    const experiments = state.getExperimentStates();

    if (!experiments) {
      return null;
    }

    const filteredExperiments = Object.keys(experiments)
      .filter((e) => e === '25993503374')
      .map((e) => experiments[e]);

    if (filteredExperiments.length !== 1) {
      return null;
    }

    return filteredExperiments[0].variation;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const emitEvent = (id, name) => {
  window['optimizely'] = window['optimizely'] || [];

  window['optimizely'].push({
    type: 'event',
    eventName: id === '25983213779' ? 'FieldA' : 'FieldB',
    tags: {
      variant: name,
      variantId: id,
    },
  });
};
